import { assistaiAppUrl } from "./common/constants/constants.js";
const normalizeHostname = (url) => {
  if (!url.startsWith("http")) {
    url = `https://${url}`;
  }
  return new URL(url).hostname;
};
const currentHostname = window.location.hostname;
const assistAIHostname = normalizeHostname(assistaiAppUrl);

export const isAssistAIURL = currentHostname === assistAIHostname;
const PRODUCT_TITLE = isAssistAIURL ? 'AssistAI' : 'TaskGPT';
// Save once
localStorage.setItem("isAssistAIURL", isAssistAIURL ? "true" : "false");


const getHostname = (url) => {
    // use URL constructor and return hostname
    return new URL(url).hostname;
}

let host = window.location.origin;
let finalHostName = getHostname(host);

const ENV = {
    base: `https://${finalHostName}/api`,
   // base: "https://taskgpt.taskus.com/api",
    botbase: "https://taskgpt.taskus.com/",
    websocket_url: "wss://taskgpt.taskus.com/ws/process_file_for_embeddings",
    websocket_receiver: "taskgpt.taskus",
    websocket_environment: "prod",
    product_title: "",
    app_title: PRODUCT_TITLE,
    cfFlag: "true",
    authUser: "prod",
      ping: isAssistAIURL ?
      {
              client_id: 'c6aac410-16ed-4593-a634-baaeed8a6749',
              auth_url: 'https://sso.connect.pingidentity.com/sso/as/authorization.oauth2',
              redirect_uri: 'https://assistai-v1.taskus.com/'
          } :
     {
        client_id: 'e52429ee-2364-46e9-9708-efc46223c9dc',
        auth_url:
            'https://sso.connect.pingidentity.com/sso/as/authorization.oauth2',
        redirect_uri: 'https://taskgpt.taskus.com/',
    },
    smartFloBaseUrl: "https://smartflo.taskus.com",
    smartFloApiBaseUrl: "https://smartflo.taskus.com/api",
    accountID: "3817830",
    trustKey: "3817830",
    agentID: "1386209468",
    licenseKey: "NRBR-ccffa55d87d34bf9829",
    applicationID: "1386209468",
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    sa: 1,
};

export const getEnv = () => {

  return ENV ;
};
